module.exports = __webpack_public_path__ + "static/img/19.9b686af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/19.png
// module id = S4G6
// module chunks = 0